import React from 'react'
import './index.css'
import comparingarrow from './../../assests/comparing-arrow.png';
import authcontext  from '../../Store/auth-context';

function SiteSettings(props) {

    const ctx = React.useContext(authcontext)
    const [isprivate, setisprivate] = React.useState(false);
    const [siteName, setsiteName] = React.useState('')
    const [city1, setcity1] = React.useState('')
    const [city2, setcity2] = React.useState('')
    const [distance, setdistance] = React.useState(null)


    React.useEffect(() => {
        console.log('sitesetting')
        fetch('https://api.evci.in/rest/v1/site/by-id', {
            method: 'POST',
            body: JSON.stringify({
                st: ctx,
                sid: props.getallsitedata.sid

            }),
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
            }
        })
            .then(function (response) {
                return response.json()
            })
            .then(function (data) {
                if(data.ack=='0'){
                
                    window.location.replace("https://sso.mpensystems.com/login?serviceURL=https://api.evci.in/sso")
                  }
            
                console.log(data)
                setcity1(data.site.city1)
                setcity2(data.site.city2)
                setdistance(data.site.distance)
                setsiteName(data.site.name)
                setisprivate(data.site.type)
            }).catch(error => console.error('Error:', error));
    }, [])

    const handlecheckbox = (e) => {
        const { value, checked } = e.target;
        console.log(checked)
        setisprivate(checked)
    }


    function siteNamehandler(event) {
        setsiteName(event.target.value)
    }

    function city1handler(event) {
        setcity1(event.target.value)
    }
    function city2handler(event) {
        setcity2(event.target.value)
    }
    const distancehandler = (e) => {
        setdistance(e.target.value);
    };

    function siteSettinghandler(event) {
        event.preventDefault();
        console.log("formsubmitted")
        const sitevalues = {
            name: siteName,
            st: ctx,
            city1: city1,
            city2: city2,
            distance: distance,
            type: isprivate ? "private" : "public"
        }


        console.log(sitevalues)

        console.log('update')
        fetch('https://api.evci.in/rest/v1/site/update', {
            method: 'POST',
            body: JSON.stringify({
                st: ctx,
                site: {
                    sid: props.getallsitedata.sid,
                    name: siteName,
                    city1: city1,
                    city2: city2,
                    distance: distance,
                    type: isprivate ? "private" : "public"
                }

            }),
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
            }
        })
            .then(function (response) {
                return response.json()
            })
            .then(function (data) {
                if(data.ack=='0'){
                
                    window.location.replace("https://sso.mpensystems.com/login?serviceURL=https://api.evci.in/sso")
                  }
            
                console.log(data)
            }).catch(error => console.error('Error:', error));

    }

    return (
        <>
            <div className='Site-setting-container'>
                <h1 className='Site-setting-heading'>Site Settings</h1>
                <br />
                <p className='Site-setting-id'>Site ID: {props.getallsitedata.sid}</p>
                {/* <p className='Site-setting-message'>Site ID is auto-generated and permanent. It cannot be changed.</p> */}
                <p className='Site-setting-id'> Owner: {props.siteusername} </p>
                <p className='Site-setting-id'> Site Name:</p>

                <form className='site-form' onSubmit={siteSettinghandler}>
                    <input type='text' className='Site-setting-site-name' value={siteName} onChange={siteNamehandler} />
                    <div className='first-input'>
                        <div className='city1'>
                            <label className='city1-label'>City 1:</label>
                            <input className='Site-setting-site-name' type="text" value={city1} onChange={city1handler} />
                        </div>
                        <img className="comparingImage" src={comparingarrow} alt="comparingarrow" />
                        <div className='city1'>
                            <label className='city1-label'>City 2:</label>
                            <input className='Site-setting-site-name' type="text" value={city2} onChange={city2handler} />
                        </div>
                    </div>
                    <label className='distance'>Length of Corridor (in Kms):</label>
                    <input className='Site-setting-site-name' type="text" value={distance} onChange={distancehandler} />

                    <label className='private'>Private:</label>
                    <p className='private-desc'>A private site is accessibly only by people it is explicitely shared with. You can make your site public if you want any user to
                        discover it and use it to run their analysis.</p>
                    <div className="form-check form-switch site-toggle-button">
                        <input className="form-check-input" type="checkbox" id="flexSwitchCheckDefault" checked={isprivate} onChange={(e) => handlecheckbox(e)} />
                        <label className="form-check-label site-toggle-button--text" for="flexSwitchCheckDefault" style={{ color: isprivate ? "#0949ad" : "" }}>{isprivate ? "Your site is private" : "Your site is public"}</label>
                    </div>

                    <button className='save--button'>Save</button>
                </form>
            </div>
        </>
    )
}

export default SiteSettings